import { toMapFn } from "~/utils/reducers";
import { CheckoutCountriesContextProvider } from "~/feature/cart/checkout/components/CheckoutOptimeCountriesContext";
import { useOnMount } from "~/common/hooks/useOnMount";
import Spinner from "~/common/components/Spinner/Spinner";
import CheckoutCart from "~/feature/cart/checkout/components/CheckoutCart";
import CheckoutFooter from "~/feature/cart/checkout/components/CheckoutFooter";
import { type RootState } from "~/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { checkoutPageMounted } from "~/feature/cart/cart/redux/actions/checkoutPageActions";
import { type DropdownEntry } from "~/common/types";
import { AlternateProductsProvider } from "~/feature/cart/cart/AlternateProductsContext";
import { CartPageContextProvider } from "~/feature/cart/cart/CartPageContext";

export function createCheckoutPage(data: { countriesJSON: string }) {
  const list: { isocode: string; name: string }[] = JSON.parse(data.countriesJSON);

  const countriesList: DropdownEntry<string>[] = list.map((item) => ({
    value: item.isocode,
    label: item.name,
    stringLabel: item.name,
  }));

  const countryByCode = toMapFn(
    list,
    (item) => item.isocode,
    (item) => item.name,
  );

  return (
    <CheckoutCountriesContextProvider value={{ countriesList, countryByCode }}>
      <CartPageContextProvider initialDisableCheckout={false} initialShowSubtotal={true}>
        <AlternateProductsProvider>
          <CheckoutPage />
        </AlternateProductsProvider>
      </CartPageContextProvider>
    </CheckoutCountriesContextProvider>
  );
}

const CheckoutPage = () => {
  const dispatch = useDispatch();
  useOnMount(() => dispatch(checkoutPageMounted()));

  const isLoading = useSelector(selectIsLoading);

  return (
    <>
      {/* TODO: remove extra padding and white background from root page container  */}
      {isLoading && <Spinner />}

      {!isLoading && (
        <>
          <CheckoutCart />

          <CheckoutFooter />
        </>
      )}
    </>
  );
};

const selectIsLoading = (state: RootState) => state.checkoutPage.loading;
